<template>
  <span class="section-menu" v-click-outside="closeMenu">
    <div class="action" v-on:click="emitOpenCancelReccuringConfirmationPopup" v-on:focusout="closeMenu">מחיקה מהתזרים</div>
  </span>
</template>

<script>
import Segment from '../../../../../../../../../../Segment';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import CancelReccuringConfirmationPopup from './CancelReccuringConfirmationPopup.vue';
import ClickOutside from '../../../../../../../../../../directives/click-outside';

export default {
  name: 'ReccuringSectionMenu',
  directives: {
    ClickOutside,
  },
  props: {
    expenseCategory: {
      type: String,
      required: true,
    },
    expenses: {
      type: Object,
      required: true,
    },
    closeMenu: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitOpenCancelReccuringConfirmationPopup() {
      Segment.trackUserInteraction('SectionMenu_CancelReccuringClicked', {
        expenseCategory: this.expenseCategory,
      });
      this.emitOpenPopup(CancelReccuringConfirmationPopup, {
        expenseCategory: this.expenseCategory,
        expenses: this.expenses,
      });
    },
    emitOpenPopup(component, props) {
      this.closeMenu();
      ModalBus.$emit('open', {
        component,
        props,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .section-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 13px;
    top: 12px;
    border-radius: 1px;
    background-color: $riseup_white;
    box-shadow: 2px 2px 8px 0 $riseup_gray_0;

    .action {
      display: flex;
      align-items: center;
      font-family: SimplerPro;
      font-size: 14px;
      padding: 0 8px;
      height: 30px;
      width: 100%;
      cursor: pointer;
      line-height: 27px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-reccuring/ReccuringSectionMenu.vue